import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/about', label: '关于我们' },
];

const gameLinks = [
  { to: '/category/jingdian-mahjong', label: '经典麻将' },
  { to: '/category/xueliu-chenghe', label: '血流成河' },
  { to: '/category/guangdong-mahjong', label: '广东麻将' },
  { to: '/category/guobiao-mahjong', label: '国标麻将' },
  { to: '/category/changsha-mahjong', label: '长沙麻将' },
  { to: '/category/single-player', label: '单机版' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [gameMenuOpen, setGameMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setGameMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 font-heading text-xl text-primary-700 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-magic-line text-2xl text-primary-500"></i>
            </span>
            <span className="hidden sm:inline">麻将电脑版在线玩</span>
            <span className="sm:hidden">麻将在线</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
                }`}
              >
                {link.label}
              </Link>
            ))}

            <div className="relative">
              <button
                onClick={() => setGameMenuOpen(!gameMenuOpen)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
                }`}
              >
                游戏玩法
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-xs transition-transform ${gameMenuOpen ? 'rotate-180' : ''}`}></i>
                </span>
              </button>

              {gameMenuOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 rounded-lg shadow-lg border border-background-200 py-2 min-w-[160px]">
                  {gameLinks.map((link) => (
                    <Link
                      key={link.to}
                      to={link.to}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/category/jingdian-mahjong"
              className="ml-3 px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即开局
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 py-3 px-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-3 px-4 rounded-md text-sm font-medium cursor-pointer ${
                location.pathname === link.to
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-primary-50/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="py-2 px-4 text-xs font-medium text-foreground-500 uppercase tracking-wide">
            游戏玩法
          </div>
          {gameLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-2 px-4 rounded-md text-sm cursor-pointer ${
                location.pathname === link.to
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-primary-50/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-3 px-4">
            <Link
              to="/category/jingdian-mahjong"
              className="block text-center py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即开局
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}